var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStartedBgMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 365,
    viewBox: "0 0 450 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M449.999 288.4C449.999 290.388 448.388 292 446.399 292L429.599 292C427.611 292 425.999 290.388 425.999 288.4L425.999 262.447C425.999 261.492 425.62 260.576 424.945 259.901L424.499 259.454C423.823 258.779 422.908 258.4 421.953 258.4L406.636 258.4C405.681 258.4 404.766 258.779 404.091 259.454L403.054 260.491C402.379 261.166 401.999 262.082 401.999 263.037L401.999 288.4C401.999 290.388 400.388 292 398.399 292L381.599 292C379.611 292 377.999 290.388 377.999 288.4L377.999 262C377.999 260.012 379.611 258.4 381.599 258.4L398.678 258.4C399.559 258.4 400.404 258.05 401.027 257.427C401.65 256.804 401.999 255.96 401.999 255.079L401.999 223.6C401.999 221.612 403.611 220 405.599 220L422.399 220C424.388 220 425.999 221.612 425.999 223.6L425.999 254.373C425.999 255.328 426.379 256.243 427.054 256.919L427.481 257.346C428.156 258.021 429.072 258.4 430.026 258.4L446.399 258.4C448.388 258.4 449.999 260.012 449.999 262L449.999 288.4Z",
    fill: "url(#paint0_linear_2_33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.244 53.8095C378.793 54.3583 379.537 54.6667 380.313 54.6667H401.072C402.688 54.6667 403.999 55.9771 403.999 57.5935V78.4065C403.999 80.023 402.688 81.3334 401.072 81.3334L380.036 81.3333C379.319 81.3333 378.632 81.618 378.125 82.1248C377.618 82.6316 377.333 83.3189 377.333 84.0356V105.073C377.333 106.69 376.023 108 374.407 108H353.594C351.977 108 350.667 106.69 350.667 105.073V84.3143C350.667 83.538 350.358 82.7936 349.81 82.2447L349.755 82.1906C349.207 81.6417 348.462 81.3333 347.686 81.3333H326.926C325.31 81.3333 323.999 80.023 323.999 78.4065V57.5935C323.999 55.9771 325.31 54.6667 326.926 54.6667H347.501C348.278 54.6667 349.022 54.3583 349.571 53.8094L349.81 53.5708C350.358 53.0219 350.667 52.2775 350.667 51.5012V30.9268C350.667 29.3104 351.977 28 353.594 28H374.407C376.023 28 377.333 29.3104 377.333 30.9268V51.6867C377.333 52.463 377.642 53.2074 378.191 53.7563L378.244 53.8095ZM376.423 55.5239C375.874 54.975 375.129 54.6667 374.353 54.6667H353.369C352.652 54.6667 351.964 54.9514 351.458 55.4582C350.951 55.965 350.666 56.6524 350.666 57.3691V78.3534C350.666 79.1297 350.974 79.8741 351.523 80.423L351.576 80.4761C352.125 81.025 352.87 81.3333 353.646 81.3333L374.168 81.3334C374.945 81.3334 375.689 81.025 376.238 80.4761L376.475 80.2392C377.024 79.6904 377.332 78.9459 377.332 78.1697V57.6456C377.332 56.8694 377.024 56.1249 376.475 55.5761L376.423 55.5239Z",
    fill: "url(#paint1_linear_2_33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3403 139.932C47.7622 140.354 47.9993 140.926 47.9993 141.523L47.9993 208.75C47.9993 209.993 49.0066 211 50.2493 211L69.7492 211C70.9918 211 71.9992 209.993 71.9992 208.75L71.9992 141.69C71.9992 141.093 72.2362 140.521 72.6582 140.099L73.0979 139.659C73.5199 139.237 74.0922 139 74.6889 139L93.4771 139C94.0739 139 94.6462 139.237 95.0681 139.659L95.3406 139.931C95.7625 140.353 95.9996 140.926 95.9996 141.522L95.9996 160.75C95.9996 161.992 97.007 163 98.2496 163L117.749 163C118.992 163 119.999 161.992 119.999 160.75L119.999 141.25C119.999 140.007 118.992 139 117.749 139L98.523 139C97.9263 139 97.354 138.763 96.9321 138.341L96.6586 138.067C96.2366 137.645 95.9996 137.073 95.9996 136.476L95.9996 117.25C95.9996 116.007 94.9922 115 93.7496 115L74.5232 115C73.9264 115 73.3541 114.763 72.9322 114.341L72.6587 114.067C72.2368 113.645 71.9997 113.073 71.9997 112.476L71.9997 93.25C71.9997 92.0074 70.9924 91 69.7497 91L50.2498 91C49.0072 91 47.9998 92.0074 47.9998 93.25L47.9998 112.643C47.9998 113.24 47.7628 113.812 47.3408 114.234L47.2335 114.341C46.8116 114.763 46.2393 115 45.6426 115L26.2494 115C25.0068 115 23.9994 116.008 23.9994 117.25L23.9994 136.644C23.9994 137.24 23.7624 137.813 23.3404 138.235L23.2341 138.341C22.8122 138.763 22.2399 139 21.6432 139L2.24999 139C1.00736 139 1.42316e-06 140.007 1.5318e-06 141.25L3.23654e-06 160.75C3.34517e-06 161.992 1.00736 163 2.24999 163L21.7499 163C22.9925 163 23.9999 161.992 23.9999 160.75L23.9999 141.689C23.9999 141.092 24.2369 140.52 24.6589 140.098L25.0976 139.659C25.5196 139.237 26.0919 139 26.6886 139L45.4768 139C46.0735 139 46.6458 139.237 47.0678 139.659L47.3403 139.932ZM48.9317 138.341C49.3537 138.763 49.926 139 50.5227 139L69.6424 139C70.2392 139 70.8115 138.763 71.2334 138.341L71.3407 138.234C71.7627 137.812 71.9997 137.24 71.9997 136.643L71.9997 117.522C71.9997 116.926 71.7627 116.353 71.3407 115.931L71.0682 115.659C70.6463 115.237 70.074 115 69.4772 115L50.689 115C50.0923 115 49.52 115.237 49.098 115.659L48.6583 116.099C48.2363 116.521 47.9993 117.093 47.9993 117.69L47.9993 136.477C47.9993 137.074 48.2363 137.646 48.6583 138.068L48.9317 138.341Z",
    fill: "url(#paint2_linear_2_33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M119.949 333.95C120.557 333.342 121.382 333 122.242 333H147.487C149.427 333 150.999 331.428 150.999 329.488V304.512C150.999 302.572 149.427 301 147.487 301H122.512C120.572 301 119 302.572 119 304.512V329.201C119 330.133 118.63 331.026 117.971 331.685L117.685 331.971C117.026 332.63 116.133 333 115.201 333H90.5116C88.5719 333 86.9995 334.572 86.9995 336.512V361.488C86.9995 363.428 88.5719 365 90.5116 365H115.487C117.427 365 118.999 363.428 118.999 361.488V336.243C118.999 335.383 119.341 334.558 119.949 333.95Z",
    fill: "url(#paint3_linear_2_33)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224 1.22392e-06C227.313 1.36877e-06 229.999 2.68629 229.999 6V34C229.999 37.3137 227.313 40 223.999 40H195.999C192.686 40 189.999 37.3137 189.999 34L189.999 6C189.999 2.68629 192.686 -1.44847e-07 195.999 0L224 1.22392e-06Z",
    fill: "url(#paint4_linear_2_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_33",
    x1: 449.999,
    y1: 256,
    x2: 377.999,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_33",
    x1: 363.999,
    y1: 28,
    x2: 363.999,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_33",
    x1: 59.9997,
    y1: 211,
    x2: 59.9997,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_33",
    x1: 118.999,
    y1: 301,
    x2: 118.999,
    y2: 365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_33",
    x1: 209.999,
    y1: -0.00000332892,
    x2: 209.999,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedBgMob);
export default __webpack_public_path__ + "static/media/getStartedBgMob.4bb22a6a2ab383c17c5d6176dd7d77e4.svg";
export { ForwardRef as ReactComponent };